function getTokenFromStorage () {
  try {
    return localStorage.getItem('token') || ''
  } catch (e) {
    return ''
  }
}

function setTokenToStorage (token) {
  try {
    if (!token) {
      localStorage.removeItem('token')
    } else {
      localStorage.setItem('token', token)
    }
  } catch (e) {
    // ignore
  }
}

export function getToken () {
  return getTokenFromStorage()
}

export function setToken (token) {
  setTokenToStorage(token)
}

export function clearToken () {
  setTokenToStorage('')
}

export function isLoggedIn () {
  return !!getTokenFromStorage()
}

